import type { ReactNode } from "react";

type HeaderProps = {
  children: ReactNode;
};

function HeaderRoot({ children }: HeaderProps) {
  return (
    <header className="flex items-center justify-between bg-white py-4 px-6 gap-4 w-full shadow-sm">
      {children}
    </header>
  );
}

export default HeaderRoot;
